/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:05:38
 * @LastEditTime: 2020-04-16 10:44:51
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import uploadDialogCtrlDom from './uploadDialogCtrl';

let uploadDialogCtrl;
const uploadDialog = (type, hasMultiple, imageUploadFun, videoUploadFun) => {
    if (!uploadDialogCtrl) uploadDialogCtrl = uploadDialogCtrlDom;
    return uploadDialogCtrl.addDialog({
        type,
        hasMultiple,
        imageUploadFun,
        videoUploadFun,
    });
};

export default {
    init(
        initParam: {
            imageUploadFun?: (img) => void;
            videoUploadFun?: (video) => void;
        } = { imageUploadFun: () => {}, videoUploadFun: () => {} }
    ) {
        return {
            upload(type: 'image' | 'video', hasMultiple: boolean = false) {
                return uploadDialog(
                    type,
                    hasMultiple,
                    initParam.imageUploadFun,
                    initParam.videoUploadFun
                );
            },
            close() {
                return uploadDialogCtrl.destroy();
            },
        };
    },
};
